// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__25AgB","signatureButtonsRight":"ModalSign_signatureButtonsRight__19Cn6"};